import React from 'react';
import classNames from 'classnames';
import { Field, Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import InputField from 'components/InputField';
import validations from 'validations';
import { Button } from 'ncoded-component-library';

import './TwoFactorStep.styles.scss';
import './TwoFactorStep.styles.responsive.scss';

export type TwoFactorStepValues = {
  code: string;
};

type TwoFactorStepProps = {
  className?: string;
  onSubmit: (values: TwoFactorStepValues) => Promise<void>;
};

const TwoFactorStep: React.FC<TwoFactorStepProps> = (props) => {
  const { className, onSubmit } = props;

  const classes = classNames('two-factor-step', className);

  const { t } = useTranslation();

  return (
    <Form
      onSubmit={onSubmit}
      render={({ handleSubmit, submitting }) => (
        <form onSubmit={handleSubmit} className={classes}>
          <h2>{t('toAccessLinkVerifyEmail')}</h2>

          <div>
            <Field
              name="code"
              component={InputField}
              label={t('verificationCode')}
              required
              validate={validations.required()}
            />
            <span />
          </div>

          <div className="actions">
            <Button type="submit" disabled={submitting}>
              {t('submit')}
            </Button>
          </div>
        </form>
      )}
    />
  );
};

export default TwoFactorStep;
